<template>
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Heart rate">
      <path
        id="Vector"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.9202 2.9165H9.07933C5.39383 2.9165 2.91699 5.51 2.91699 9.36817V18.6315C2.91699 22.4897 5.39383 25.0832 9.07933 25.0832H18.919C22.6068 25.0832 25.0837 22.4897 25.0837 18.6315V9.36817C25.0837 5.51 22.6068 2.9165 18.9202 2.9165Z"
        fill="#8F42FF" />
      <path
        id="Vector_2"
        d="M17.8292 14.8745H19.3295C19.8125 14.8745 20.2045 14.4825 20.2045 13.9995C20.2045 13.5165 19.8125 13.1245 19.3295 13.1245H17.198C16.8224 13.1245 16.4875 13.3649 16.3685 13.723L15.5985 16.0295L13.2302 8.92692C13.1112 8.56992 12.7775 8.32959 12.4007 8.32959C12.0239 8.32959 11.6902 8.57109 11.5712 8.92692L10.1712 13.1245H8.6709C8.1879 13.1245 7.7959 13.5165 7.7959 13.9995C7.7959 14.4825 8.1879 14.8745 8.6709 14.8745H10.8024C11.1792 14.8745 11.5129 14.633 11.6319 14.276L12.4007 11.9707L14.769 19.0722C14.888 19.428 15.2217 19.6695 15.5985 19.6695C15.9754 19.6695 16.3102 19.4292 16.4292 19.0722L17.8292 14.8745Z"
        fill="white" />
    </g>
  </svg>
</template>
